import React from 'react';

import {
  type AccountType,
  type TextSizeType,
  sizeToSvgWidth,
} from '../../utils';
import { Entry } from '../svg/Entry';

type EntryIconProps = {
  types: AccountType[];
  size?: TextSizeType;
  disabled?: boolean;
};

export const EntryIcon = ({
  types,
  size = 'sm',
  disabled,
}: EntryIconProps): JSX.Element => (
  <Entry
    types={types}
    width={sizeToSvgWidth[size as keyof typeof sizeToSvgWidth]}
    disabled={disabled}
  />
);
